import axiosClient from "../axiosInstance";

const base = "/admin/exports";

/**
 * Ranking exports, as a file.
 *
 * The response is a Blob rather than JSON, so this returns the whole axios
 * response: the caller needs the blob and, in production, the server's
 * Content-Disposition.
 */
export const downloadRankingsExport = async (params) => {
  const response = await axiosClient.get(`${base}/rankings`, {
    params,
    responseType: "blob",
  });
  return response;
};

const exportService = {
  downloadRankingsExport,
};

export default exportService;
